// If you change this list, there could be an impact in data-transformation (data/academic_emails.csv & data/academic_emails_to_academie.csv)
//Maybe warn data team about this change
export const validAcademicEmailDomains = [
    'lalilo.com',
    'ac-aix-marseille.fr',
    'ac-amiens.fr',
    'ac-besancon.fr',
    'ac-bordeaux.fr',
    'ac-caen.fr',
    'ac-clermont.fr',
    'ac-corse.fr',
    'ac-creteil.fr',
    'ac-dijon.fr',
    'ac-grenoble.fr',
    'ac-guadeloupe.fr',
    'ac-guyane.fr',
    'ac-lille.fr',
    'ac-limoges.fr',
    'ac-lyon.fr',
    'ac-martinique.fr',
    'ac-mayotte.fr',
    'ac-montpellier.fr',
    'ac-nancy-metz.fr',
    'ac-nantes.fr',
    'ac-nice.fr',
    'ac-normandie.fr',
    'ac-noumea.nc',
    'ac-orleans-tours.fr',
    'ac-paris.fr',
    'ac-poitiers.fr',
    'ac-polynesie.pf',
    'ac-reims.fr',
    'ac-rennes.fr',
    'ac-reunion.fr',
    'ac-rouen.fr',
    'ac-strasbourg.fr',
    'ac-toulouse.fr',
    'ac-versailles.fr',
    'ac-wf.wf',
    'province-sud.nc',
    'province-nord.nc',
    'gouv.nc',
    'education.gouv.fr',
    'loyalty.nc',
    'ac-spm.fr',
];
//# sourceMappingURL=academic-email-domains.js.map